export default {
  TRAVELBTA: 'TRAVELBTA',
  APINDIVIDUAL: 'APINDIVIDUAL',
  AUTO: 'AUTO',
  PYMES: 'PYMES',
  HOGAR: 'HOGAR',
  HOGAR_DTC: 'hogarCotizadorDTC',
  HOGAR_FLEX: 'hogarCotizadorFlex',
  pymesAbiertoInd: 'pymesAbiertoInd',
  LINEAS_FINANCIERAS: 'lnPresRcpa',
  lnPresRcpa: 'lnPresRcpa',
  RCPA: 'RCPA',
  RCP: 'lnPresRcp',
  CYBER: 'lnPresCyber',
  PRESUSCRITOS: 'pymesCerradoInd',
  DO: 'lnPresDO',
  MARINE_INLAND: 'MARINEINLAND',
  CASUALITY: 'CASUALTYCONTRATISTAS',
  CASUALITY_GENERAL: 'CASUALTYGENERALES',
  SEGUKIDS:'SKT'
};
